import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

import useAuth from "../hooks/useAuth";

import { PATH_DASHBOARD } from "../routes/paths";

import LoadingScreen from "../components/LoadingScreen";
import { origin } from "./AuthGuard";

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isAuthenticated) {
    if (!window.location.origin.includes("http://localhost:3000")) {
      window.location.replace(origin[window.location.origin]);
    }
  }
  if (isAuthenticated) {
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
}
